"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { LAST_PROJECT_STORAGE_KEY } from "@/lib/lastProject";

export function SidebarCreateLink() {
  const [href, setHref] = useState("/projects");

  useEffect(() => {
    const lastProjectId = localStorage.getItem(LAST_PROJECT_STORAGE_KEY);
    // Straight to the generation screen: the button says "Создать", and the dashboard is a
    // place to look rather than a place to make something.
    if (lastProjectId) setHref(`/projects/${lastProjectId}/generate`);
  }, []);

  return (
    <Link
      href={href}
      className="rounded bg-signal-red px-3 py-2 text-center text-sm font-medium uppercase tracking-wide text-white hover:opacity-90"
    >
      Создать
    </Link>
  );
}
